class LanguageController {
    $onInit() {
        this.elements = this.elements || [];
    }
}

export default LanguageController;


//////////////////
// WEBPACK FOOTER
// ./src/language/language.controller.js
// module id = 638
// module chunks = 0